import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="border-y border-navy-700 bg-navy" data-id="element-16" data-mp="pio8yn0kl492">
      <div className="mx-auto max-w-page px-4 py-12 sm:px-5 lg:py-24" data-id="element-17" data-mp="au1x4va5iuml">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between sm:gap-4" data-id="element-18" data-mp="ftmtqz1umqw5">
          <h2 id="bonuses-heading" className="max-w-xl font-display text-2xl font-extrabold leading-[1.08] tracking-[-0.03em] text-white sm:text-4xl" data-id="element-19" data-mp="1tvl7du3q2pj">
            Included today at no extra cost
          </h2>
          <p className="text-[13px] text-mist sm:text-sm" data-id="element-20" data-mp="3o369yhbo54hb">
            Real value <span className="text-steel line-through" data-id="element-21" data-mp="3szwr77z7m64b">$250</span> — today{' '}
            <span className="font-semibold text-gold" data-id="element-22" data-mp="1mai563jdm8zf">completely free</span> with the System.
          </p>
        </div>

        <ul className="mt-8 grid gap-4 sm:mt-12 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3" data-id="element-23" data-mp="1r9l5xbsbpt1l">
          {bonuses.map(bonus => <li key={bonus.number} className="flex flex-col overflow-hidden rounded-lg border border-navy-700 bg-navy-900" data-id="element-24" data-mp="3icvan7ku2bzt">
              <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="aspect-[4/3] w-full object-cover" width={1024} height={768} data-id="element-25" data-mp="3r7013pw21let" />
              <div className="flex flex-1 flex-col p-6" data-id="element-26" data-mp="2zfu7lsaualyi">
                <div className="flex items-center justify-between" data-id="element-27" data-mp="2uh951m847q6w">
                  <span className="flex items-center gap-2 font-display text-[11px] font-bold uppercase tracking-[0.18em] text-steel" data-id="element-28" data-mp="38g8totvmo532">
                    <GiftIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-29" data-mp="33gw5a4p3ypyd" />
                    Bonus {bonus.number}
                  </span>
                  <span className="text-[11px] uppercase tracking-[0.1em] text-steel" data-id="element-30" data-mp="ns47u21lbu64">
                    <span className="line-through" data-id="element-31" data-mp="iqome8vi3ln7">{bonus.value}</span>{' '}
                    <span className="font-bold text-gold" data-id="element-32" data-mp="3ci4vzfzbxnte">Free</span>
                  </span>
                </div>
                <h3 className="mt-4 font-display text-lg font-extrabold leading-tight tracking-[-0.02em] text-white" data-id="element-33" data-mp="3hg6d3vd73d28">
                  {bonus.title}
                </h3>
                <p className="mt-auto pt-3 text-sm leading-relaxed text-mist" data-id="element-34" data-mp="3qhmnw47x9h6z">
                  {bonus.description}
                </p>
              </div>
            </li>)}
          <li className="flex flex-col justify-center rounded-lg border border-gold/50 bg-navy-800 p-8" data-id="element-35" data-mp="2xtihfghj1038">
            <p className="font-display text-3xl font-extrabold tracking-[-0.03em] text-gold" data-id="element-36" data-mp="32sv15sd3pr1l">
              $250 free
            </p>
            <p className="mt-3 text-sm leading-relaxed text-mist" data-id="element-37" data-mp="37lein0ewt6bo">
              All five bonuses land in your account the moment you join — no upsells, no waiting.
            </p>
          </li>
        </ul>
      </div>
    </section>;
}